import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { useNavigate } from 'react-router';
import { get, post, postFormData } from '../../ApiServices/ApiServices';
import Loader from '../Component/Loader';
import { useSelector } from 'react-redux';

function SizeChart() {
    const [isLoading, setIsLoading] = useState(true); // Changed to true initially
    const [data, setData] = useState([]);
    const [categoryLoading, setCategoryLoading] = useState({});
    const [editCell, setEditCell] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [sizeid, setsizeid] = useState(1);
    const navigate = useNavigate();
    const profile = useSelector((state) => state.profile.profile);
    const isAdmin = profile?.name === "Admin";
    const GetSize = async () => {
        try {
            setIsLoading(true);
            const api = `all-size-chart-categories`;
            const totalData = await get(api);
            setData(totalData?.data);

            const initialLoadingState = {};
            totalData?.data.forEach((category) => {
                initialLoadingState[category.id] = true;
            });
            setCategoryLoading(initialLoadingState);

            setTimeout(() => {
                setCategoryLoading({});
            }, 1000);
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error fetching inventory data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        GetSize();
    }, []);

    const handleDoubleClick = (categoryId, sizeId, field, value) => {
        if (!isAdmin) return;
        setEditCell({ categoryId, sizeId, field });
        setEditValue(value === '---' ? '' : String(value || ''));
    };

    const handleInputChange = (e) => {
        setEditValue(e.target.value);
    };

    const handleEditComplete = async (categoryId, sizeId, field, originalValue) => {
        if (!editCell) return;

        let safeEditValue = String(editValue || '').trim();
        const isEmpty = safeEditValue === '' || safeEditValue === '---';

        if (field === 'minHeight' || field === 'maxHeight') {
            if (!isEmpty && !safeEditValue.includes("'")) {
                alert("Please include feet marker (') in height");
                setEditCell(null);
                setEditValue('');
                return;
            }
        }

        const valueToSend = isEmpty ? null : safeEditValue;

        try {
            setData(prevData =>
                prevData.map(cat => {
                    if (cat.id === categoryId) {
                        return {
                            ...cat,
                            size_charts: cat.size_charts.map(size => {
                                if (size.id === sizeId) {
                                    const updatedSize = { ...size };

                                    updatedSize[field] = valueToSend === null ? '---' : valueToSend;

                                    if (field === 'minHeight') {
                                        updatedSize.minHeightShow = valueToSend === null ? '---' : valueToSend;
                                    } else if (field === 'maxHeight') {
                                        updatedSize.maxHeightShow = valueToSend === null ? '---' : valueToSend;
                                    }

                                    return updatedSize;
                                }
                                return size;
                            })
                        };
                    }
                    return cat;
                })
            );

            const updateData = { id: sizeId };
            updateData[field] = valueToSend;

            const payload = { size_charts: [updateData] };
            const api = `edit-size-chart-category/${sizeid}`;

            await post(api, payload);
        } catch (err) {
            console.error('Error updating size chart:', err);
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setEditCell(null);
            setEditValue('');
        }
    };

    const handleKeyDown = (e, categoryId, sizeId, field, originalValue) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            handleEditComplete(categoryId, sizeId, field, originalValue);
        } else if (e.key === 'Escape') {
            setEditCell(null);
            setEditValue('');
        }
    };

    const renderCell = (categoryId, sizeId, field, value) => {
        const isEditing =
            editCell &&
            editCell.categoryId === categoryId &&
            editCell.sizeId === sizeId &&
            editCell.field === field;

        if (isEditing && isAdmin) {
            return (
                <input
                    type="text"
                    className="form-control form-control-sm"
                    value={editValue}
                    onChange={handleInputChange}
                    onBlur={() => handleEditComplete(categoryId, sizeId, field, value)}
                    onKeyDown={(e) => handleKeyDown(e, categoryId, sizeId, field, value)}
                    autoFocus
                    style={{ width: '20px', minWidth: '40px', maxHeight: '10px', padding: '0px' }}
                />
            );
        }

        return (
            <span
                onDoubleClick={() => handleDoubleClick(categoryId, sizeId, field, value)}
                style={{ display: 'block', width: '100%', minHeight: '24px', cursor: 'pointer' }}
            >
                {value}
            </span>
        );
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm pbZeroHeadin">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title"> Size Chart</h3>
                                        {
                                            isAdmin && <p className="text-muted mb-3">Double-click on any cell to edit its value. For height values, use format: 5'0"</p>
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* Updated rendering logic */}
                            {isLoading ? (
                                <Loader />
                            ) : data && data.length > 0 ? (
                                <div className="card card-preview inventoryTabs sizeChart">
                                    <div className="card-inner">
                                        <div className="mResponsive">
                                            <ul className="nav nav-tabs mt-n3 brNone">
                                                {data.map((category, index) => (
                                                    <li key={category.id} className="nav-item" onClick={() => { setsizeid(category.id) }}>
                                                        <a className={`nav-link w-100 ${index === 0 ? 'active' : ''}`} data-bs-toggle="tab" href={`#tabItem${category.id}`}>
                                                            {category.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        {data.map((category, index) => (
                                            <div className="tab-content sizeChartTable">
                                                <div key={category.id} className={`tab-pane ${index === 0 ? 'active' : ''}`} id={`tabItem${category.id}`}>
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Coat Size</th>
                                                                    <th scope="col" colSpan="2">Height</th>
                                                                    <th scope="col" colSpan="2">Weight</th>
                                                                    <th scope="col" colSpan="2">Waist</th>
                                                                    <th scope="col" colSpan="2">Outseam</th>
                                                                    <th scope="col" colSpan="2">Neck</th>
                                                                    <th scope="col" colSpan="2">Shirt Sleeve</th>
                                                                    <th scope="col" colSpan="2">Shoe</th>
                                                                    <th scope="col" colSpan="2">Hip</th>
                                                                    <th scope="col" colSpan="2">Vest </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="row">Size</th>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <td scope="row"><b>Min</b></td>
                                                                    <td scope="row"><b>Max</b></td>
                                                                    <th scope="row"> Size </th>
                                                                </tr>
                                                                {categoryLoading[category.id] ? (
                                                                    <tr>
                                                                        <td colSpan="18" className="text-center">
                                                                            <Loader />
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    category.size_charts.map((size) => {
                                                                        return (
                                                                            <tr key={size.id}>
                                                                                <th scope="row">
                                                                                    {renderCell(category.id, size.id, 'coatSize', size?.coatSize || '---')}
                                                                                </th>
                                                                                <td>{renderCell(category.id, size.id, 'minHeight', size?.minHeightShow || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxHeight', size?.maxHeightShow || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minWeight', size?.minWeight || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxWeight', size?.maxWeight || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minWaist', size?.minWaist || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxWaist', size?.maxWaist || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minOutseam', size?.minOutseam || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxOutseam', size?.maxOutseam || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minNeck', size?.minNeck || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxNeck', size?.maxNeck || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minShirtSleeve', size?.minShirtSleeve || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxShirtSleeve', size?.maxShirtSleeve || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minShoe', size?.minShoe || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxShoe', size?.maxShoe || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'minHip', size?.minHip || '---')}</td>
                                                                                <td>{renderCell(category.id, size.id, 'maxHip', size?.maxHip || '---')}</td>
                                                                                <td>
                                                                                    {renderCell(category.id, size.id, 'vestSize', size?.vestSize || '---')}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                !isLoading && <div className="alert alert-info">No size chart data available</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default SizeChart;